import { DbrBalloonEntity } from '@balloon-race-fullstack-monorepo/dbr-rest-api';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace BalloonStateActions {
  export class SetActiveBalloon {
    static readonly type = "[Balloon] SetActiveBalloon";

    constructor(public balloon: DbrBalloonEntity | null) {
    }
  }
}
